import React from 'react';
import styled from 'styled-components';
import Header from '../compositions/Header';

const Container = styled.div`
  padding: 21px;
  display: block;
`;

type MainPageType = {
  children: React.ReactNode;
};

export default function MainPage({ children }: MainPageType) {
  return (
    <>
      <Container>
        <Header />
      </Container>
      {children}
    </>
  );
}
